(() => {
  const PARTNERSHIP = 'Deeb partnerships and collaborations';

  class DeebContactPage {
    constructor(root) {
      this.root = root;
      this.select = root.querySelector('[data-deeb-contact-select]');
      this.organization = root.querySelector('[data-deeb-contact-organization]');
      this.organizationInput = this.organization?.querySelector('input');
      this.applyEnquiryPreset();
      this.initSelect();
      this.syncOrganization();
    }

    applyEnquiryPreset() {
      const preset = new URLSearchParams(window.location.search).get('enquiry');
      if (preset?.trim().toLowerCase() !== 'partnerships' || !this.select) return;

      const radio = this.select.querySelector(`input[name="contact[Enquiry type]"][value="${PARTNERSHIP}"]`);
      const value = this.select.querySelector('[data-deeb-contact-select-value]');
      const label = radio?.closest('label')?.querySelector('[data-deeb-contact-option-label]');

      if (!radio) return;
      radio.checked = true;
      if (value && label) value.textContent = label.textContent.trim();
    }

    initSelect() {
      if (!this.select) return;

      const summary = this.select.querySelector('summary');
      const value = this.select.querySelector('[data-deeb-contact-select-value]');
      const radios = [...this.select.querySelectorAll('input[type="radio"]')];

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const label = radio.closest('label')?.querySelector('[data-deeb-contact-option-label]');
          if (value && label) value.textContent = label.textContent.trim();
          this.syncOrganization();
          this.select.open = false;
          summary?.focus();
        });
      });

      this.select.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.select.open) return;
        event.preventDefault();
        this.select.open = false;
        summary?.focus();
      });

      document.addEventListener('click', (event) => {
        if (this.select.open && !this.select.contains(event.target)) this.select.open = false;
      });
    }

    syncOrganization() {
      if (!this.organization || !this.organizationInput) return;

      const selected = this.root.querySelector('input[name="contact[Enquiry type]"]:checked');
      const active = selected?.value === PARTNERSHIP;

      this.organization.hidden = !active;
      this.organizationInput.disabled = !active;
      this.organizationInput.required = active;
      this.organizationInput.setAttribute('aria-required', active ? 'true' : 'false');

      if (active) {
        this.organization.classList.remove('is-entering');
        requestAnimationFrame(() => this.organization.classList.add('is-entering'));
      } else {
        this.organization.classList.remove('is-entering');
        this.organizationInput.value = '';
      }
    }
  }

  const boot = () => {
    document.querySelectorAll('[data-deeb-contact]').forEach((root) => {
      if (root.dataset.deebContactReady === 'true') return;
      root.dataset.deebContactReady = 'true';
      new DeebContactPage(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
